import getApi from '@/lib/axios';
import { ColumnModel, CrmType } from '../types';

export type ColumnDTO = ColumnModel;

async function createColumn(payload: ColumnDTO) {
  const api = await getApi();

  return api.post<CrmType>('/crm/colunas/', payload);
}

export { createColumn };
